module.exports = __webpack_public_path__ + "img/VU.f52b4616.svg";